<template>
  <v-container class="bottom">
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11 xl10>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <div>
        <v-snackbar
          class="new-alert"
          v-model="alert"
          :timeout="timeout"
          :color="alertType"
          top="top"
        >
          {{this.alertMessage}}
          <v-icon color="white" flat @click="alert = false">close</v-icon>
        </v-snackbar>
      </div>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12>
          <v-layout row>
            <v-flex md12 lg12 xs12 sm12>
              <h2 class="titlep">Priorización de estrategias en la próxima década.</h2>
              <p
                class="pull"
              >Desde las diversas iniciativas estratégicas planteadas por las respectivas unidades académicas, se han categorizado en grandes estratégicas institucionales. En relación a estas estrategias institucionales se deberán priorizar a través de bienios. Las estrategias priorizadas para el año 2020 – 2021 serán las que se abordarán a través de Planes de Desarrollo Disciplinar año 2020.</p>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <label class="left" for="sel1">Ejes Estratégicos</label>
              <select class="form-control" id="5" @change="cargarPoliticas()" v-model="eje">
                <option selected disabled>-Selecciona una opción-</option>
                <option value="1">Desarrollo territorial</option>
                <option value="2">Desarrollo tecnológico, innovación y emprendimiento</option>
                <option value="3">Inclusión e igualdad de género</option>
                <option value="4">Sostenibilidad</option>
                <option value="5">Internacionalización e interculturalidad</option>
              </select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md12 lg12 xs12 sm12>
              <table id="secondTable" class="table">
                <thead>
                  <tr>
                    <th>Estrategias</th>
                    <th v-for="(col,index) in headers2" :key="index">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{col}}</span>
                        </template>
                      </v-tooltip>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in politicas" :key="index">
                    <td style="text-align:left">{{item.nombrePolitica}}</td>
                    <td
                      style="text-align:left"
                      :class="claseElegida"
                      :id="String(index) + '-' + String(1) "
                      @click="selecciona(String(index) + '-' + String(1),item,'periodo1')"
                    ></td>
                    <td
                      style="text-align:left"
                      :class="claseElegida"
                      :id="String(index) + '-' + String(2) "
                      @click="selecciona(String(index) + '-' + String(2),item,'periodo2')"
                    ></td>
                    <td
                      style="text-align:left"
                      :class="claseElegida"
                      :id="String(index) + '-' + String(3) "
                      @click="selecciona(String(index) + '-' + String(3),item,'periodo3')"
                    ></td>
                    <td
                      style="text-align:left"
                      :class="claseElegida"
                      :id="String(index) + '-' + String(4) "
                      @click="selecciona(String(index) + '-' + String(4),item,'periodo4')"
                    ></td>
                    <td
                      style="text-align:left"
                      :class="claseElegida"
                      :id="String(index) + '-' + String(5) "
                      @click="selecciona(String(index) + '-' + String(5),item,'periodo5')"
                    ></td>
                    <td>
                      <v-icon small class="mr-2" @click="cargarEstrategias(item.id)">info</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-btn
              v-if="this.$session.getAll().permiso"
              color="#EB7704"
              @click="savePoliticas()"
            >Guardar cambios</v-btn>
            <v-btn
              v-if="this.$session.getAll().permiso && this.$session.getAll().userType=='dge'"
              color="#EB7704"
              @click="descargarPriorizacion()"
            >Descargar Información</v-btn>
          </v-layout>
          <br />
        </v-flex>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="iniciativasModal" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-progress-circular v-if="loading" :size="100" :width="10" color="#e47215" indeterminate></v-progress-circular>

          <v-flex md12 lg12 xs12 sm12 xl12 v-if="!loading">
            <table class="table table-striped header-fixed">
              <thead>
                <tr>
                  <th style="text-align: center">Iniciativas</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in hitos" :key="index">
                  <td style="text-align:left ">{{item.nombreEstrategia}}</td>
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="iniciativasModal = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>


<script>
import img1 from "../../assets/BANNER_3.png";
import img3 from "../../assets/nuevaasistenciadca.png";

export default {
  data() {
    return {
      loading: true,
      eje: "",
      iniciativasModal: false,
      ccValor: "",
      img3: img3,
      img1: img1,
      seleccion: 1,
      politicas: [],
      headers2: [
        "2020-2021",
        "2022-2023",
        "2024-2025",
        "2026-2027",
        "2028-2029"
      ],
      rows: [],
      selected: [],
      timeout: 4000,
      alertType: "success",
      alertMessage: "",
      alert: false,
      create: false,
      edit: false,
      index: "",
      claseElegida: "new1",
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  watch: {
    seleccion: function() {
      this.changeClass();
    },
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },
  created() {
    this.initComponent();
  },
  methods: {
    initComponent() {
      this.ccValor = this.$session.getAll().ccData.ccValor;
      //TODO: ver que renderizar si x alguna razón hay error
      this.eje = 1;
      this.cargarPoliticas();
    },
    savePoliticas() {
      //console.log("SAVEEEEEEEEEEEEE");
      //console.log(this.politicas);
      axios
        .post(
          process.env.ROOT_API + "/politica/updatePeriodos",
          this.politicas,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert(
            "success",
            "La priorización de las estrategias se ha realizado correctamente"
          );
          this.cargarPoliticas();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
    },

    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    },

    cargarPoliticas() {
      axios
        .get(
          process.env.ROOT_API +
            "/politica/allPoliticas?ccValor=" +
            this.ccValor +
            "&idEje=" +
            this.eje +
            "&ano=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => {
          this.politicas = response.data;
          //console.log(this.politicas);
        })
        .catch(error => {
          console.error(error);
        })
        .then(response => {
          //console.log("mounted");
          var i;
          for (i = 0; i < this.politicas.length; i++) {
            var j;
            for (j = 1; j <= 5; j++) {
              //console.log(this.politicas[i]);
              this.pinta(this.politicas[i], String(i) + "-" + String(j), j);
            }
          }
        });
    },

    cargarEstrategias(idPolitica) {
      this.loading = true;
      this.iniciativasModal = true;
      axios
        .get(
          process.env.ROOT_API +
            "/estrategia/allEstrategiasByPolitica?ano=2021&idPolitica=" +
            idPolitica,
          this.auth
        )
        .then(response => {
          this.hitos = response.data;
          //console.log(this.hitos);
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
        });
    },

    pinta(politica, index, indexcol) {
      if (politica["periodo" + String(indexcol)] === "1") {
        document.getElementById(index).style.backgroundColor = "#63cb67";
      } else {
        document.getElementById(index).style.backgroundColor = "white";
      }
    },

    descargarPriorizacion() {
      axios
        .get(process.env.ROOT_API + "/estrategia/exportPriorizacion", {
          responseType: "arraybuffer",
          headers: { Authorization: "" + this.$session.get("jwt") }
        })
        .then(response => {
          this.forceFileDownload(response, "Detalle priorización estrategias ");

          //console.log(this.hitos);
        })
        .catch(error => {
          console.error(error);
        });
    },

    forceFileDownload(response, tipo) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", tipo + "- General.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    selecciona(index, item, periodo) {
      //console.log("van las Rows meris");
      //console.log(index);
      if (item[periodo] === "1") {
        document.getElementById(index).style.backgroundColor = "white";
        item[periodo] = "0";
      } else if (item[periodo] === "0" || item[periodo] === null) {
        document.getElementById(index).style.backgroundColor = "#63cb67";
        item[periodo] = "1";
      }
    }
  }
};
</script>


<style scoped>
.new-alert {
  z-index: 9000;
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.new-alert .theme--light.v-icon {
  color: #ffffff !important;
}
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}
.marginnull {
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
}
.tooltip {
  text-align: center;
}
table {
  font-family: "Open Sans", sans-serif;
  border-collapse: collapse;
  border: 1px solid #e47215;
  margin: 5px 5px 0 5px;
  border-radius: 20%;
}
.new1:hover {
  background-color: #63cb67;
  cursor: pointer;
  -webkit-transition: background-color 0.5s ease-out;
  -moz-transition: background-color 0.5s ease-out;
  -o-transition: background-color 0.5s ease-out;
  transition: background-color 0.5s ease-out;
}

.new2:hover {
  background-color: rgb(72, 120, 192);
  cursor: pointer;
  -webkit-transition: background-color 0.5s ease-out;
  -moz-transition: background-color 0.5s ease-out;
  -o-transition: background-color 0.5s ease-out;
  transition: background-color 0.5s ease-out;
}

table {
  font-family: "Open Sans", sans-serif;
  border-collapse: collapse;
  border: 1px solid #e47215;
  margin: 5px 5px 0 5px;
  border-radius: 20%;
}
table th {
  text-align: left;
  background: #e47215;
  color: #fff;
  padding: 8px !important;
  border-radius: 5%;
}

table td {
  text-align: left;
  padding: 8px !important;
  font-size: 14px;
  border-right: 1px solid #e47215;
}
.table > tbody > tr > td,
.table > tfoot > tr > td,
.table > thead > tr > td {
  padding: 4px !important;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}

table td:last-child {
  border-right: none;
}
table tbody tr:nth-child(n) td {
  background: white;
  height: 30px !important;
  -webkit-transition: background-color 1s ease-out;
  -moz-transition: background-color 1s ease-out;
  -o-transition: background-color 1s ease-out;
  transition: background-color 1s ease-out;
}

table tbody {
  overflow-y: auto;
  height: 100px;
  position: relative;
}

.new1 {
  cursor: pointer;
}

.new2 {
  cursor: pointer;
}
.text-mision {
  font-size: 16px;
  text-align: justify;
}
ul.padding {
  padding-left: 30px !important;
  padding-right: 60px !important;
}

.container--style {
  padding-left: 3% !important;
  padding-right: 3% !important;
  padding-bottom: 0% !important;
  width: 100% !important;
  background-color: #394049 !important;
}

.titlep {
  color: #ec6a12;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 343px !important;
  overflow-y: auto;
}

.v-card {
  height: auto;
  overflow-y: auto;
  padding-left: 2% !important;
  padding-right: 2% !important;
}

.font {
  color: white !important;
}

.pull {
  text-align: justify;
}

.new-card {
  height: auto;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

p.bold {
  font-weight: bold;
  color: white;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.image {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/planes de desarrollo/PriorizacionPolitica.vue